import { render } from "./ClimateCommunitySustainability.vue?vue&type=template&id=59b68011&scoped=true"
import script from "./ClimateCommunitySustainability.vue?vue&type=script&lang=js"
export * from "./ClimateCommunitySustainability.vue?vue&type=script&lang=js"

import "./ClimateCommunitySustainability.vue?vue&type=style&index=0&id=59b68011&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_e6558ed2e51dee85cd0a9e429c286fa8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59b68011"]])

export default __exports__